import React from "react";
import PageWitchMenu from "../components/mui/page_witch_menu/PageWitchMenu";
import useScrollUp from "../hooks/useScrollUp";
import LoaderContainer from "../components/mui/loader_container/LoaderContainer";
import { useAppSelector } from "../store/index.ts";
import useCheckPathname from "../hooks/useCheckPathname.js";
import LandingContent from "../components/landing/LandingContent.jsx";
import "./main.scss";

export default function Main() {
  useScrollUp();
  useCheckPathname();

  const loader = useAppSelector((state) => state.site.mainLoader);
  const categoryLoading = useAppSelector((state) => state.games.categoryLoading);
  const errorInfo = useAppSelector((state) => state.site.errorInfo);

  return (
    <LoaderContainer center loader={loader || categoryLoading || errorInfo} fullHeight>
      <PageWitchMenu className={"landing"}>
        <LandingContent />
      </PageWitchMenu>
    </LoaderContainer>
  );
}
